import Model from '../views/models/model';
import OntologyHelper from '../views/models/ontology_helper';
import settings from '../liferay/settings';

//const rpc_url = "http://62.61.8.56:8080/web/guest/testview1?p_p_id=view_WAR_SetupViewportlet_INSTANCE_Hxff7boaseW4&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_cacheability=cacheLevelPage";
//const rpc_url = "http://62.61.8.56:8080/web/guest/testview1?p_p_id=view_WAR_SetupViewportlet_INSTANCE_GcY9GYvE0qa3&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_cacheability=cacheLevelPage";
//const rpc_url = "http://62.61.8.56:8080/web/guest/testview1?p_p_id=view_WAR_SetupViewportlet_INSTANCE_b6x4ExQorcCw&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_cacheability=cacheLevelPage";
//const rpc_url = "http://csi2.semanticpro.org/web/guest/catalog?p_p_id=view_WAR_SetupViewportlet_INSTANCE_a3N7HAXk4O7o&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_cacheability=cacheLevelPage";
//ХББ
//const rpc_url = "http://62.61.8.56:8080/web/guest/setupview?p_p_id=setupview_WAR_SetupViewportlet&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_cacheability=cacheLevelPage";                 
//ЦСИ
//const rpc_url = "http://csi2.semanticpro.org/web/guest/setup-views?p_p_id=setupview_WAR_SetupViewportlet&p_p_lifecycle=2&p_p_state=normal&p_p_mode=view&p_p_cacheability=cacheLevelPage";
const rpc_url = settings.rpc_url;

/**
 * Получение информации о настроенных представлениях
 */
export const ModelViews = {
  EMPTY: () => ({
      type: ModelViews.EMPTY,
  }),
  LOAD_STARTED: () => ({
      type: ModelViews.LOAD_STARTED,
  }),
  LOAD_ERROR: (error) => ({
      type: ModelViews.LOAD_ERROR,
      error
  }),
  LOAD_VIEWS: (iri, model, ontology, views) => ({
      type: ModelViews.LOAD_VIEWS,
      iri, model, ontology, views,
  }),
  getRpc_url: () => {return rpc_url},
  /** Загрузить информацию ассетах */
  loadViews: (iri) => dispatch => {
    dispatch(ModelViews.LOAD_STARTED());
    const model = new Model(rpc_url);      
		return Promise.all([
      model.getOntology(),
      model.getViews(iri),
    ]).then(response => {
        const ontology = new OntologyHelper(response[0]);
        const views = response[1].list;
        dispatch(ModelViews.LOAD_VIEWS(iri, model, ontology, views));
        return Promise.resolve(response);
			})
      .catch(e => { 
        dispatch(ModelViews.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        return Promise.reject(e);
    });
  },

}